// VARIABLES //
var is_mobile;

var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
var is_explorer = navigator.userAgent.indexOf('MSIE') > -1;
var is_firefox = navigator.userAgent.indexOf('Firefox') > -1;
var is_safari = navigator.userAgent.indexOf("Safari") > -1;
var is_opera = navigator.userAgent.toLowerCase().indexOf("top") > -1;
if ((is_chrome)&&(is_safari)) {is_safari=false;}
if ((is_chrome)&&(is_opera)) {is_chrome=false;}

var doc = ($('html').hasClass('ie8')) ? window : document;

// ROTATION UX //
function rotate_ux() {
	var container = $('.ux');
	var content = $('.ux--message');

	if (Modernizr.touchevents && Modernizr.mq('(orientation: landscape) and (max-device-width: 667px)')) {
		$('.ux').css('display','block');
		$('body').css('overflow','hidden');
	} else {
		$('.ux').css('display','none');
		$('body').css('overflow','auto');
	}
}

// CENTRER VERTICALEMENT //
function verticalAlignCenter() {
	jQuery(".vertical-align-center").each(function() {
		var $elem = $(this);
		var elemHeight = $elem.height();
		if (elemHeight == 0)	// perhap's an element is no loaded
			return;
		var $container = $elem.parent();
		var marginTop = Math.floor(($container.height() - elemHeight) / 2);
		if (marginTop > 0)
			$elem.css("margin-top", marginTop);
		$elem.removeClass("vertical-align-center");
	});
}

// PLACEHOLDER //
function placeholder_func() {
	jQuery( "input" ).each(function( index ) {
		if(jQuery(this).attr('data-placeholder')) {
			var placeholder = jQuery(this).attr('data-placeholder');
			// console.log( placeholder );
			if(jQuery(this).attr('value') == '') {
				jQuery(this).attr('value', placeholder);
			}
			jQuery(this).click(function(event) {
		    	event.stopPropagation();
				if(jQuery(this).attr('value') == placeholder) {
					jQuery(this).attr('value', '');
				}
			});
		}
	});
	jQuery('html').click(function() {
		jQuery( "input" ).each(function( index ) {
			if(jQuery(this).attr('data-placeholder')) {
				var placeholder = jQuery(this).attr('data-placeholder');
				if(jQuery(this).attr('value') == '') {
					jQuery(this).attr('value', placeholder);
				}
			}
		});
	});
}
